/* eslint-disable react/react-in-jsx-scope */
import classNames from 'classnames'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Button } from '@mui/material'

export type AddNewFundingRoundProps = ExtendableStyles &
  Testable & {
    onCreate: () => void
  }

export function AddNewFundingRound({ className, onCreate, ...otherProps }: AddNewFundingRoundProps) {
  const { classes } = useStyles()
  return (
    <Button
      color="secondary"
      variant="contained"
      className={classNames(classes.button, className)}
      onClick={onCreate}
      {...otherProps}
    >
      Add new funding event
    </Button>
  )
}

const useStyles = makeStyles()({
  button: {
    position: 'relative',
  },
})
